<div class="login-wrapper">
  <div class="backdrop-wrapper d-flex align-items-center justify-content-center">
    <div class="login-container">
      <div *ngIf="appContext.isSunip">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="SunIP"/>
      </div>
      <div *ngIf="appContext.isForecaster">
        <img src="{{appContext.fullLogoColor}}" style="height: 100px" title="ChiefIP"/>
      </div>
      <div *ngIf="appContext.isLegalsight">
        <img src="{{appContext.fullLogoColor}}" style="height: 70px" title="LegalSight"/>
      </div>

	    <townip-standard-alert *ngIf="showResetSuccess" class="mt-4" mode="lite" type="success">
		    Your password was successfully reset!
	    </townip-standard-alert>

	    <h2 class="h5 mt-4 text-body-2 font-weight-bold" style="font-size: 20px;">Multi-Factor Authentication</h2>
	    <p>Enhance security by enabling MFA and verifying your phone number to receive sign-in codes.</p>

	    <form #mfaForm="ngForm">
		    <div class="d-flex align-items-center mt-4">
			    <p-inputSwitch class="d-block mr-2" [(ngModel)]="mfaActive" name="mfaActive"></p-inputSwitch>
			    <div class="mb-1">Activate Multi-Factor Authentication</div>
		    </div>

		    <!-- Do not use -->
		    <div [hidden]="!mfaActive">
			    <div class="d-flex align-items-end mt-4">
				    <div class="form-group mb-0">
					    <label>Phone Number</label>
					    <input
                autocomplete="off"
						    required
						    [readonly]="mfaCodeSent"
						    class="form-control standard-control otp-input"
						    placeholder="+1 123 456 7890"
						    type="text"
						    [(ngModel)]="mfaPhone"
						    name="mfaPhone" />
				    </div>
				    <button
					    [disabled]="mfaCodeSent"
					    type="button"
					    (click)="sendPhoneNumberVerification(mfaForm)"
					    id="btn-verify-phone"
					    class="btn btn-primary ml-2">
					    Verify Phone Number
				    </button>
			    </div>

			    <townip-standard-alert *ngIf="!mfaCodeSent && mfaError" class="mt-2" type="danger" mode="lite">
				    {{mfaErrorMsg}}
			    </townip-standard-alert>

			    <ng-container *ngIf="mfaCodeSent">
				    <div class="form-group mt-4">
					    <label>Enter SMS verification code sent to {{mfaPhone | phoneMask}}.</label>
					    <townip-otp-code
						    name="mfaVerificationCode"
						    [(ngModel)]="mfaVerificationCode"
						    [forceInvalid]="(otpVal.touched && otpVal.invalid) || mfaError">
					    </townip-otp-code>
					    <input
						    type="hidden"
						    #otpVal="ngModel"
						    [(ngModel)]="mfaVerificationCode"
						    name="otpPlaceHolder"
                required
						    [minlength]="6" />
				    </div>

				    <townip-standard-alert *ngIf="mfaError" class="mt-2" type="danger" mode="lite">
					    {{mfaErrorMsg}}
				    </townip-standard-alert>

				    <p class="mt-4">Didn't receive Verification Code?</p>
				    <button
              #btnResend
					    [disabled]="resendDisabled"
					    type="button"
					    id="btn-resend"
					    class="btn btn-sm btn-primary-outline"
					    (click)="resendCode(btnResend)">
					    Resend Code
				    </button>
				    <button
					    type="button"
					    class="btn btn-sm btn-primary-outline"
					    (click)="changePhoneNumber()">
					    Change Phone Number
				    </button>
				    <townip-standard-alert class="mt-2" type="danger" mode="lite" style="width: 400px;" *ngIf="timerCount > 0">
					    You can resend the code again in {{timerCount}} seconds.
				    </townip-standard-alert>
			    </ng-container>
		    </div>

		    <div class="mt-5">
			    <button class="btn btn-secondary btn-lg" (click)="cancel()">Cancel</button>
			    <button
				    type="submit"
				    class="btn btn-primary btn-lg"
				    (click)="verifyCode(mfaForm)">
				    Confirm
			    </button>
		    </div>
	    </form>
    </div>
  </div>
</div>
